import { Stack, styled } from '@mui/material';
import { ReactNode } from 'react';

const ChatInfoBackground = styled(Stack, {
  name: 'ChatInfoBackground',
  shouldForwardProp: (prop) => prop !== 'backgroundColor' && prop !== 'textColor',
})<{ backgroundColor?: string; textColor?: string }>(({
  theme,
  backgroundColor,
  textColor,
}) => {
  return {
    color: textColor ?? theme.palette.custom.OV.sys.secondary,
    background: backgroundColor ?? theme.palette.custom.OV.sys.secondaryContainer,
    borderTopRightRadius: theme.shape.borderRadius,
    borderTopLeftRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    position: 'relative',
    textWrap: 'wrap',
    zIndex: 1,

    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: theme.shape.borderRadius * -1,
      left: 0,
      width: '100%',
      height: theme.shape.borderRadius,
      background: backgroundColor ?? theme.palette.custom.OV.sys.secondaryContainer,
    },

    '.timestamp': {
      opacity: 1,
    },
  };
});

export const ChatInfo = ({
  message,
  backgroundColor,
  textColor,
}: {
  message?: ReactNode;
  backgroundColor?: string;
  textColor?: string;
}) => {
  if (!message) {
    return;
  }

  return (
    <ChatInfoBackground
      direction="row"
      alignItems="center"
      gap={1}
      backgroundColor={backgroundColor}
      textColor={textColor}
    >
      {message}
    </ChatInfoBackground>
  );
};
